import { DialogBase } from '@scale/dialog-base';
import { DrawerOpenEvent, DrawerCloseEvent, ToastEvent } from '@scale/events';
import { followCartChange } from '@scale/cart-motion';

class ScaleCartDrawer extends DialogBase {
  static observeRefs = true;

  get useHistory() {
    return true;
  }

  get swipeToClose() {
    return true;
  }

  get dialogId() {
    return 'cart-drawer';
  }

  setupDialog() {
    this.onDocument('shopify:cart:lines-update', (event) => this.#onCartLinesUpdate(event));
    this.onDocument('shopify:cart:error', (event) => this.#onCartError(event));
  }

  updatedCallback() {
    this.invalidateRefs();
  }

  onDialogOpen() {
    this.broadcast(new DrawerOpenEvent('cart-drawer'));
  }

  onDialogClose() {
    this.broadcast(new DrawerCloseEvent('cart-drawer'));
  }

  #onCartLinesUpdate(event) {
    followCartChange(this, event);
    if (event.action !== 'add') return;
    event.promise?.then(() => {
      this.broadcast(new ToastEvent(Scale.translations.addedToCart, { type: 'success' }));
      if (this.dataset.openOnAdd === 'true' && this.dataset.cartIconBehavior !== 'page') {
        queueMicrotask(() => this.open());
      }
    }).catch(() => {});
  }

  #onCartError(event) {
    if (event.target.closest?.('[data-cart-error-in-place]')) return;
    this.broadcast(new ToastEvent(event.error, { type: 'error' }));
  }
}

if (!customElements.get('scale-cart-drawer')) {
  customElements.define('scale-cart-drawer', ScaleCartDrawer);
}
